import { ProjectType } from '../../data/gql-gen/dashboard/graphql'
import { useGetProjectByProjectId } from '../../modules/Project/Project.hooks'
import { MultiMarketRoutes } from './MultiMarket/MultiMarketRoutes'
import { TrackerRoutes } from './Tracker'

/**
 * Dispatches /project/:projectId on project type. Renders nothing until the
 * query settles, or a tracker flashes the multi-market breadcrumb on the way in.
 */
export const ProjectRoutes = () => {
  const { project, loading } = useGetProjectByProjectId()

  if (loading) {
    return null
  }

  return project?.projectType === ProjectType.Tracker ? (
    <TrackerRoutes />
  ) : (
    <MultiMarketRoutes />
  )
}
